import { createAction, props, union } from '@ngrx/store';
import { SfContact, SfOpportunity } from '../../model/salesforce.model';
import { data } from '../reducers/createFormations.reducers';

export enum CreateFormationActionTypes {
    SET_STORE = '[CREATEFORMATION] Set Store',
    SET_Opportunity = '[CREATEFORMATION] Set Opportunity',
    SET_Contact = '[CREATEFORMATION] SET Contact',
    SET_ErrorMessage = '[CREATEFORMATION] SET Error Message',
    SET_FormationInfos = '[CREATEFORMATION] SET FormationInfos',
    SET_GenetalInfos = '[CREATEFORMATION] SET GenetalInfos',
    SET_Step = '[CREATEFORMATION] SET Step',
    ADD_Formation = '[CREATEFORMATION] ADD Formations',
    EDIT_Formation = '[CREATEFORMATION] EDIT Formations',
    DELETE_Formation = '[CREATEFORMATION] DELETE Formations',
    ADD_User = '[CREATEFORMATION] ADD User',
    ADD_Account = '[CREATEFORMATION] ADD Account',
    CLEAR_STORE = '[CREATEFORMATION] Clear STORE',
}

export const SetStore = createAction(
    CreateFormationActionTypes.SET_STORE,
    props<{ data: data }>()
)

export const SetOpportunity = createAction(
    CreateFormationActionTypes.SET_Opportunity,
    props<{ opportunity: SfOpportunity }>()
)

export const SetContact = createAction(
    CreateFormationActionTypes.SET_Contact,
    props<{ contact: SfContact }>()
)

export const AddUserToCreate = createAction(
    CreateFormationActionTypes.ADD_User,
    props<{ user: any }>()
)

export const AddAccountToCreate = createAction(
    CreateFormationActionTypes.ADD_Account,
    props<{ account: any }>()
)

export const AddFormationToCreate = createAction(
    CreateFormationActionTypes.ADD_Formation,
    props<{ formation: any }>()
)

export const SetFormationsInfos = createAction(
    CreateFormationActionTypes.SET_FormationInfos,
    props<{ infos: any }>()
)

export const SetGeneralInfos = createAction(
    CreateFormationActionTypes.SET_GenetalInfos,
    props<{ infos: any }>()
)

export const SetStep = createAction(
    CreateFormationActionTypes.SET_Step,
    props<{ step: number }>()
)

export const SetErrorMessage = createAction(
    CreateFormationActionTypes.SET_ErrorMessage,
    props<{ message: any }>()
)

export const EditFormationToCreate = createAction(
    CreateFormationActionTypes.EDIT_Formation,
    props<{ position: any, formation:any }>()
)

export const DeleteFormationToCreate = createAction(
    CreateFormationActionTypes.DELETE_Formation,
    props<{ position: any }>()
)

export const ClearStore = createAction(
    CreateFormationActionTypes.CLEAR_STORE,
)

const actions = union({
    SetOpportunity,
    SetContact,
    AddFormationToCreate,
    SetGeneralInfos,
    AddAccountToCreate,
    AddUserToCreate,
    SetErrorMessage,
    SetStep,
    EditFormationToCreate,
    DeleteFormationToCreate,
    SetStore,
    ClearStore,
    SetFormationsInfos
});
  
export type CreateFormationActionsUnions = typeof actions;